import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://th.bing.com/th/id/R.3cca809024079d5a26741fe974026e70?rik=NPLshKmdsZYALA&riu=http%3a%2f%2fmedia.cntraveler.com%2fphotos%2f598339c9b7a86962e8e27c5d%2fmaster%2fpass%2fParis_GettyImages-601763009.jpg&ehk=1sSok1VLsf46Z7UigpsucOVYwAclWQL1zfyCy5qdbiw%3d&risl=&pid=ImgRaw&r=0',
  },
  {
    label: 'Bird',
    imgPath:
      'https://th.bing.com/th/id/OIP.Q6j8ylf-vDw1CfBIVTD-wAAAAA?pid=ImgDet&rs=1',
  },
  {
    label: 'Bali, Indonesia',
    imgPath:
      'https://s2.r29static.com/bin/entry/ed5/0,0,3809,2000/x,80/1718233/image.jpg',
  },
  {
    label: 'Goč, Serbia',
    imgPath:
      'https://th.bing.com/th/id/OIP.eFQMDMv0cAYmlGeZKwiB4AHaE8?pid=ImgDet&rs=1https://th.bing.com/th/id/OIP.eFQMDMv0cAYmlGeZKwiB4AHaE8?pid=ImgDet&rs=1',
  },
];

function Carousel(props) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ maxWidth: '40vw', flexGrow: 1 }}>
      {/* <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper> */}
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {props.images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="img"
                sx={{
                  height: 200,
                  display: 'block',
                  maxWidth: '40vw',
                  overflow: 'hidden',
                  width: '125%',
                }}
                src={step.imgPath}
                alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </Button>
        }
      />
    </Box>
  );
}

export default Carousel;